// The synthetic date dimensions every partition offers regardless of what its columns list
// carries — v3 `utils/helpers.js:363`, injected by `getPartitionColumns` (DataVisible.js:363-377)
// so a user can always break a report down by week/day-of-week/month even when the backend
// partition never enumerates them.
//
// NOTE: `service/sortRows.ts` and `service/reportQueryString.ts` each hold a private copy of this
// same list (verified identical). They are not switched over here — neither file is in this
// change's path, and their copies are provably equivalent, so there is nothing to fix in them
// today beyond the duplication itself.
export const DATE_DIMENSIONS = [
  'date',
  'day_of_week',
  'week',
  'day_of_month',
  'day_of_year',
  'month_of_year',
] as const
